import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_layout/device/mobile')({
  beforeLoad: ({ search }) => {
    const showOtp = search?.showOtp === true;

    throw redirect({
      to: showOtp ? '/device/apps/connect' : '/device/apps',
      replace: true,
    });
  },
});
